/**
 * BAS Automation - Animations
 * Advanced scroll animations, parallax effects, and interactions
 */

(function() {
  'use strict';

  // ===================================
  // Scroll Animation Observer
  // ===================================
  const animateOnScroll = () => {
    const elements = document.querySelectorAll('.animate-on-scroll');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(element => observer.observe(element));
  };

  // ===================================
  // Parallax Effect
  // ===================================
  const parallaxEffect = () => {
    const parallaxElements = document.querySelectorAll('[data-parallax]');
    
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      
      parallaxElements.forEach(element => {
        const speed = element.dataset.parallax || 0.5;
        const yPos = -(scrolled * speed);
        element.style.transform = `translateY(${yPos}px)`;
      });
    });
  };

  // ===================================
  // Mouse Follow Effect
  // ===================================
  const mouseFollowEffect = () => {
    const hero = document.querySelector('.hero');
    
    if (hero) {
      hero.addEventListener('mousemove', (e) => {
        const { clientX, clientY } = e;
        const { offsetWidth, offsetHeight } = hero;
        
        const xPos = (clientX / offsetWidth - 0.5) * 20;
        const yPos = (clientY / offsetHeight - 0.5) * 20;
        
        const elements = hero.querySelectorAll('.hero-content > *');
        elements.forEach((element, index) => {
          const depth = (index + 1) * 0.1;
          element.style.transform = `translate(${xPos * depth}px, ${yPos * depth}px)`;
        });
      });
    }
  };

  // ===================================
  // Floating Animation
  // ===================================
  const floatingAnimation = () => {
    const floatingElements = document.querySelectorAll('[data-float]');
    
    floatingElements.forEach((element, index) => {
      element.style.animation = `float ${3 + index * 0.5}s ease-in-out infinite`;
      element.style.animationDelay = `${index * 0.2}s`;
    });
  };

  // ===================================
  // Card Tilt Effect
  // ===================================
  const cardTiltEffect = () => {
    const cards = document.querySelectorAll('.feature-card, .product-card');
    
    cards.forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const rotateX = (y - centerY) / 10;
        const rotateY = (centerX - x) / 10;
        
        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;
      });
      
      card.addEventListener('mouseleave', () => {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale(1)';
      });
    });
  };

  // ===================================
  // Gradient Animation on Hover
  // ===================================
  const gradientHoverEffect = () => {
    const buttons = document.querySelectorAll('.btn-primary');
    
    buttons.forEach(button => {
      button.addEventListener('mousemove', (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        button.style.setProperty('--mouse-x', `${x}px`);
        button.style.setProperty('--mouse-y', `${y}px`);
      });
    });
  };

  // ===================================
  // Smooth Scroll
  // ===================================
  const smoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        if (href !== '#' && href !== '#!') {
          const target = document.querySelector(href);
          
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  };

  // ===================================
  // Text Reveal Animation
  // ===================================
  const textRevealAnimation = () => {
    const textElements = document.querySelectorAll('[data-text-reveal]');
    
    textElements.forEach(element => {
      const text = element.textContent;
      element.textContent = '';
      
      const chars = text.split('');
      chars.forEach((char, index) => {
        const span = document.createElement('span');
        span.textContent = char === ' ' ? '\u00A0' : char;
        span.style.opacity = '0';
        span.style.display = 'inline-block';
        span.style.animation = `fadeInUp 0.5s ease forwards ${index * 0.03}s`;
        element.appendChild(span);
      });
    });
  };

  // ===================================
  // Intersection Observer for Stats
  // ===================================
  const observeStats = () => {
    const stats = document.querySelectorAll('.hero-stat, .stat-item');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.animation = 'scaleIn 0.6s ease forwards';
          }, index * 100);
        }
      });
    }, { threshold: 0.5 });
    
    stats.forEach(stat => observer.observe(stat));
  };

  // ===================================
  // Magnetic Button Effect
  // ===================================
  const magneticButtons = () => {
    const buttons = document.querySelectorAll('.btn');
    
    buttons.forEach(button => {
      button.addEventListener('mousemove', (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        button.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
      });
      
      button.addEventListener('mouseleave', () => {
        button.style.transform = 'translate(0, 0)';
      });
    });
  };

  // ===================================
  // Scroll Progress Indicator
  // ===================================
  const scrollProgress = () => {
    const progressBar = document.createElement('div');
    progressBar.className = 'scroll-progress';
    progressBar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      height: 3px;
      background: linear-gradient(90deg, #7C3AED, #3B82F6);
      z-index: 9999;
      transition: width 0.1s ease;
    `;
    document.body.appendChild(progressBar);
    
    window.addEventListener('scroll', () => {
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (window.scrollY / windowHeight) * 100;
      progressBar.style.width = scrolled + '%';
    });
  };

  // ===================================
  // Initialize All Animations
  // ===================================
  const init = () => {
    animateOnScroll();
    parallaxEffect();
    mouseFollowEffect();
    floatingAnimation();
    cardTiltEffect();
    gradientHoverEffect();
    smoothScroll();
    observeStats();
    magneticButtons();
    scrollProgress();
    
    // Text reveal on page load
    if (document.querySelector('[data-text-reveal]')) {
      textRevealAnimation();
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Add stagger animation delay to grid items
  const addStaggerDelay = () => {
    const grids = document.querySelectorAll('.grid, .features-grid, .product-grid');
    
    grids.forEach(grid => {
      const items = grid.children;
      Array.from(items).forEach((item, index) => {
        item.style.animationDelay = `${index * 0.1}s`;
      });
    });
  };

  window.addEventListener('load', addStaggerDelay);

})();


